import styled from 'styled-components'

import { ListDisplayBlock as ListDisplayBlockType } from '../../types/blueprint'
import { DisplayDescription } from '../DisplayBlock.style'

const List = styled.div`
  margin-top: 1rem;
  list-style-position: inside;
  padding-left: 0;
`

const ListItem = styled.li`
  &:not(:last-child) {
    margin-bottom: 0.25rem;
  }
`

type Props = {
  block: ListDisplayBlockType
}

export const ListDisplayBlock: React.FC<Props> = ({ block }) => {
  const { items, description, listType } = block

  const isOrdered = listType === 'ordered'

  return (
    <>
      {description && <DisplayDescription>{description}</DisplayDescription>}
      <List as={isOrdered ? 'ol' : 'ul'}>
        {items?.map((item) => (
          <ListItem key={item.label}>{item.label}</ListItem>
        ))}
      </List>
    </>
  )
}
